import React, { useState } from 'react';
import { SearcherCard } from '../components/newcoordination/SearcherCard.es';
import { useBetween } from 'use-between';
import { CoordinationList } from '../components/newcoordination/CoordinationList';
import { useFetchCards } from '../hooks/card/useFetchCards';
import { usePaginationCard } from '../hooks/card/usePaginationCard';
import { ExportMessages } from "../components/ExportMessages";
import { ImportMessages } from "../components/ImportMessages";
import { AddCoordination } from '../components/AddCoordination';

export const CardScreen = () => {

    const useSharedPagination = () => useBetween(usePaginationCard);

    const { state: cards, setState: setCards } = useFetchCards();

    const useExportModal = () => {
        const [exportModal, setExportModal] = useState({ visible: false, data: {} });
        return {
            exportModal, setExportModal
        }
    }

    const useImportModal = () => {
        const [importModal, setImportModal] = useState({ visible: false, data: {}, formData: '' });
        return {
            importModal, setImportModal
        }
    }

    const useAddCoordinationModal = () => {
        const [addCoordinationModal, setAddCoordinationModal] = useState({ visible: false, data: {}, formData: '' });
        return {
            addCoordinationModal, setAddCoordinationModal
        }
    }

    const useSharedExportModal = () => useBetween(useExportModal);
    const useSharedImportModal = () => useBetween(useImportModal);
    const useSharedAddCoordinationModal = () => useBetween(useAddCoordinationModal);

    return (
        <>
            <SearcherCard cards={cards} setCards={setCards} pagination={useSharedPagination} useAddCoordinationModal={useSharedAddCoordinationModal} />
            <CoordinationList cards={cards} setCards={setCards} useExportModal={useSharedExportModal} useImportModal={useSharedImportModal} />
            <ExportMessages useExportModal={useSharedExportModal} />
            <ImportMessages useImportModal={useSharedImportModal} />
            <AddCoordination useAddCoordinationModal={useSharedAddCoordinationModal} />
        </>
    )
}